import React from "react";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import Dialog from "../../Services/Common/Dialog";
import IndexedDb from "../../Services/IndexedDb/IndexedDb";
/** Components Import */
import SM10020View from "../../Views/Sales/SM10020";
import SM10021View from "../../Views/Sales/SM10021";
import Snackbar from "../../Components/Snackbar";

function SM10020(props) {
  const [snackbars, setSnackbars] = React.useState({
    toggle: false,
    type: "",
    message: "",
  });
  const [lanData, setLanData] = React.useState([]);
  const [tabToggle, setTabToggle] = React.useState(false);
  const [inputs, setInputs] = React.useState({
    comboValue: "",
    searchInput: "",
  });
  const [orderList, setOrderList] = React.useState([]);
  const [rowData, setRowData] = React.useState([]);
  const today = new Date();
  const monthAgo = new Date(today);
  const [startDate, setStartDate] = React.useState(
    monthAgo.setMonth(today.getMonth() - 3)
  );
  const [endDate, setEndDate] = React.useState(new Date());

  React.useEffect(() => {
    window.addEventListener("error", (e) => {
      if (e.message === "ResizeObserver loop limit exceeded") {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client- overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
    Init();
  }, []);

  const Init = async () => {
    Dialog.ProgressBar(true);
    let getLanData = [];
    let getRowData = [];
    let getRowData1 = [];

    try {
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      setLanData(getLanData);
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });

      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl +
          Global.urls.logic.Sales.SM10020.GetSalesOrders,
        {
          type: inputs.comboValue ? inputs.comboValue : "string",
          value:
            inputs.comboValue === "ContractDt"
              ? Commons.DateFormating(startDate, 2)
              : inputs.searchInput
              ? inputs.searchInput
              : "string",
          StartDate: new Date(startDate),
          EndDate: new Date(endDate),
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setOrderList([]);
          setSnackbars({
            toggle: true,
            type: "info",
            message: getLanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else if (data.type === "Error") {
          if (lanData.length != 0) {
            setSnackbars({
              toggle: true,
              type: "info",
              message: getLanData.filter(
                (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
              )[0].lanName,
            });
          }
        } else {
          for (let i = 0; i < data.length; i++) {
            getRowData.push({
              name:
                data[i].itemNm == null
                  ? ""
                  : data[i].itemNm +
                    " \n" +
                    (data[i].soDueDt
                      ? Commons.DateFormating(data[i].soDueDt.toString(), 2)
                      : "") +
                    " \n" +
                    (data[i].soDueNo ? data[i].soDueNo : ""),
              status: data[i].stusCd,
            });
          }
          for (let i = 0; i < data.length; i++) {
            getRowData1.push({
              whNm: data[i].whNm,
              plantCd: data[i].plantCd,
              plantNm: data[i].plantNm,
              soNo: data[i].soNo,
              contractDt: data[i].contractDt
                ? Commons.DateFormating(data[i].contractDt.toString(), 2)
                : "",
              custCd: data[i].custCd,
              custNm: data[i].custNm,
              itemCd: data[i].itemCd,
              itemNm: data[i].itemNm == null ? "" : data[i].itemNm,
              itemQty: data[i].itemQty,
              WorkQty: data[i].WorkQty,
              delivAmt: data[i].delivAmt,
              difference: data[i].itemQty - data[i].WorkQty,
              stusNm: data[i].stusNm,
              itemVatYn: data[i].itemVatYn,
              itemStdAmt: data[i].itemStdAmt,
              poItemCost:
                data[i].itemVatYn === "Y" ? data[i].itemStdAmt * 1.1 : 0,
              poWonAmt:
                data[i].itemVatYn === "Y"
                  ? data[i].itemQty * data[i].itemStdAmt * 1.1
                  : data[i].itemQty * data[i].itemStdAmt,
              soDueNo: data[i].soDueNo,
              soDueDt: data[i].soDueDt
                ? Commons.DateFormating(data[i].soDueDt.toString(), 2)
                : "",
              workDt: data[i].workDt
                ? Commons.DateFormating(data[i].workDt.toString(), 2)
                : "",
              itemUnit: data[i].itemUnit,
            });
          }

          setOrderList(getRowData);
          setRowData(getRowData1);
        }
      });
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  return (
    <div className="card">
      <ul className="tab_nav" style={{ marginTop: "5px" }}>
        <li>
          <a
            className={tabToggle ? "" : "active"}
            onClick={() => setTabToggle(false)}
          >
            {lanData.length > 0
              ? lanData.filter(
                  (f) =>
                    f.lanId === "Fom_OrderStatus(List)" && f.lanType === "FORM"
                )[0].lanName
              : ""}
          </a>
        </li>
        <li>
          <a
            className={!tabToggle ? "" : "active"}
            onClick={() => setTabToggle(true)}
          >
            {lanData.length > 0
              ? lanData.filter(
                  (f) =>
                    f.lanId === "Fom_OrderStatus(Grid)" && f.lanType === "FORM"
                )[0].lanName
              : ""}
          </a>
        </li>
      </ul>
      {!tabToggle ? (
        <SM10020View
          Init={Init}
          lanData={lanData}
          setSnackbars={setSnackbars}
          orderList={orderList}
          inputs={inputs}
          setInputs={setInputs}
          setStartDate={setStartDate}
          startDate={startDate}
          setEndDate={setEndDate}
          endDate={endDate}
        />
      ) : (
        <SM10021View
          Init={Init}
          rowData={rowData}
          setRowData={setRowData}
          inputs={inputs}
          setInputs={setInputs}
          lanData={lanData}
          setStartDate={setStartDate}
          startDate={startDate}
          setEndDate={setEndDate}
          endDate={endDate}
        />
      )}
      {snackbars.toggle && (
        <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />
      )}
    </div>
  );
}

export default SM10020;
